<!-- ViewDetail.vue -->
<template>
  <div>
    <el-dialog :title="title" :visible.sync="isDialog" width="70%" append-to-body @close="handleCancel">
      <div class="detail-container">
        <h2>告警报告详情</h2>
        <el-row :gutter="20">
          <!-- 每行两个字段 -->
          <el-col :span="12">
            <p><strong>设备类型：</strong>{{ detail.deviceType }}</p>
          </el-col>
          <el-col :span="12">
            <p><strong>设备名称：</strong>{{ detail.equipmentName }}</p>
          </el-col>
          <el-col :span="12">
            <p><strong>设备编码：</strong>{{ detail.equipmentNumber }}</p>
          </el-col>
          <el-col :span="12">
            <p><strong>告警类型：</strong>{{ detail.typeStr }}</p>
          </el-col>
          <el-col :span="12">
            <p><strong>告警标题：</strong>{{ detail.title }}</p>
          </el-col>
          <el-col :span="12">
            <p><strong>告警内容：</strong>{{ detail.content }}</p>
          </el-col>
          <el-col :span="12">
            <p><strong>告警时间：</strong>{{ detail.alarmTime }}</p>
          </el-col>
        </el-row>
        <div class="action-buttons">
                    <el-button type="info" @click="handleCancel" size="small" class="cancel-btn">
                        取消
                    </el-button>
                </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ViewDetail',
  props: {
    detailInfo: {
      type: Object,
      required: true
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    detail() {
      console.log(this.detailInfo,'this.detailInfo')
      return this.detailInfo;
    }
  },
  methods: {
    // 可以添加格式化方法
    formatDate(date) {
      return new Date(date).toLocaleString();
    },
    handleCancel() {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>
.detail-container {
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    max-height: 80vh;
    overflow-y: auto;
}

.detail-container h2 {
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

.detail-container p {
    margin: 8px 0;
    line-height: 1.6;
}

.detail-container strong {
    color: #333;
    font-weight: 600;
}

.code-block {
    background: #f5f5f5;
    padding: 10px;
    border-radius: 4px;
    font-family: 'Courier New', monospace;
    font-size: 12px;
    overflow-x: auto;
    margin-top: 5px;
    white-space: pre-wrap;
    word-break: break-all;
    max-height: 200px;
    overflow-y: auto;
}

.action-buttons {
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid #eee;
    text-align: right;
}

.cancel-btn {
    margin-right: 10px;
}
</style>